import { BaseQuestionPreviewComponent } from '../../../bases';
import { jsx as _jsx } from "react/jsx-runtime";
export var EssayPreviewComponent = function EssayPreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  return /*#__PURE__*/_jsx(BaseQuestionPreviewComponent, {
    states: states,
    actions: actions
  });
};